import { REGIONS, YEARS, SORTS, type SortValue } from '@/utils/movie';

interface FilterBarProps {
  region: string;
  year: string;
  sort: SortValue;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onSort: (v: SortValue) => void;
  onReset: () => void;
}

function ChipRow({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: string[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="w-12 shrink-0 text-sm text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
              value === opt
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-700 hover:bg-background-200'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterBar({ region, year, sort, onRegion, onYear, onSort, onReset }: FilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col gap-4">
        <ChipRow label="地区" options={REGIONS} value={region} onChange={onRegion} />
        <ChipRow label="年份" options={YEARS} value={year} onChange={onYear} />

        <div className="flex flex-wrap items-center gap-3">
          <span className="w-12 shrink-0 text-sm text-foreground-500">排序</span>
          <div className="inline-flex items-center gap-1 rounded-full bg-background-100 px-1 py-1">
            {SORTS.map((s) => (
              <button
                key={s.value}
                type="button"
                onClick={() => onSort(s.value)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  sort === s.value ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-600'
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={onReset}
            className="ml-auto inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            <i className="ri-refresh-line" /> 重置筛选
          </button>
        </div>
      </div>
    </div>
  );
}